import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ScanQualityPackButton } from '../../features/quality-packs/scan-quality-pack-button';

export const Route = createFileRoute('/quality-packs')({
  staticData: {
    permissionSection: 'quality',
    breadcrumb: 'Quality Packs',
    // Shown top-right of the header on every /quality-packs route (list, pack
    // detail, check detail) — declared once here, inherited by all children.
    headerActions: () => <ScanQualityPackButton />,
  },
  component: QualityPacksLayout,
});

function QualityPacksLayout() {
  return <Outlet />;
}
